import React from 'react'
import PropTypes from 'prop-types'

import CustomLink from '@shared/components/customLink'

const XIItems = ({ styles, data }) => {
  return (
    <>
      <span className={`${styles.playerName} d-flex justify-content-between align-items-center`}>
        {data?.oPlayer?.oSeo?.eStatus === 'a' && data?.oPlayer?.eTagStatus === 'a' && data?.oPlayer?.oSeo?.sSlug ? (
          <CustomLink href={`/${data?.oPlayer?.oSeo?.sSlug}`}>{data?.oPlayer?.sFullName || data?.oPlayer?.sFirstName}</CustomLink>
        ) : (
          data?.oPlayer?.sFullName || data?.oPlayer?.sFirstName
        )}
        {/* {data?.isCaptain && data?.isWicketKeeper && (
          <span className="me-auto text-center text-primary xsmall-text">
            <span className="ms-1 d-block rounded-circle">
              ({"C"})({"wk"})
            </span>
          </span>
        )} */}
        {data?.isCaptain && (
          <span className="ms-1 me-auto d-block text-primary text-center xsmall-text rounded-circle">({'C'})</span>
        )}
        {data?.isWicketKeeper && (
          <span className="ms-1 me-auto text-primary text-center xsmall-text rounded-circle">({'wk'})</span>
        )}

        <span className="text-muted small-text">{data?.oPlayer?.sPlayingRole && data?.oPlayer?.sPlayingRole?.toUpperCase()}</span>
      </span>
    </>
  )
}

XIItems.propTypes = {
  styles: PropTypes.any,
  data: PropTypes.object
}

export default XIItems
